import { atom } from "recoil"
import { PlanModelDetail } from "src/apis/paidTeam/getOrderDetail"

export const orderPrePlanState = atom<PlanModelDetail>({
  key: "atoms/paidTeam/orderPrePlanState",
  default: undefined,
})
